import React from 'react';
import { CheckCircle } from 'lucide-react';

const S3ServerAccessLogsDetails = ({ testDetails, testId, getRegionStatusDisplay }) => {
  const message = testDetails.message || '';
  const regionsChecked = testDetails.regions_checked || [];
  const regionDetails = testDetails.region_details || {};

  return (
    <>
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4">
        <p className="text-blue-700">{message}</p>
      </div>

      <div className="mb-4">
        <h4 className="font-medium mb-2">Regions Checked</h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {regionsChecked.map((region) => (
            <div key={region} className="bg-gray-50 rounded-md p-2 text-sm">
              {region}
            </div>
          ))}
        </div>
      </div>

      <div className="mb-4">
        <h4 className="font-medium mb-2">Region Details</h4>
        {Object.entries(regionDetails).map(([region, details]) => (
          <div key={region} className="border border-gray-200 rounded-md mb-3">
            <div className="flex justify-between items-center p-3 bg-gray-50 border-b border-gray-200">
              <h5 className="font-medium">Region: {region}</h5>
              <span className={`px-2 py-1 rounded-md text-sm ${getRegionStatusDisplay(details, testId).className}`}>
                {getRegionStatusDisplay(details, testId).text}
              </span>
            </div>
            <div className="p-3">
              <p className="mb-2">{details.message}</p>
              {details.bucket_details && details.bucket_details.length > 0 ? (
                <div className="mt-3">
                  <h6 className="font-medium mb-2">S3 Bucket Details</h6>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bucket Name</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Access Logging Enabled</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Bucket</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {details.bucket_details.map((bucket) => (
                          <tr key={bucket.bucket_name}>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700">{bucket.bucket_name}</td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm">
                              {bucket.has_logging ? (
                                <span className="text-green-600 flex items-center">
                                  <CheckCircle size={16} className="mr-1" /> Yes
                                </span>
                              ) : (
                                <span className="text-red-600">No</span>
                              )}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700">
                              {bucket.target_bucket || 'N/A'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <p className="text-gray-500 italic">No S3 buckets found in this region</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default S3ServerAccessLogsDetails;
